module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col s12 m8 l8"
  }, [_c('iframe', {
    staticClass: "hide-on-med-and-up z-depth-4",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3764.98176657906!2d-41.25751408509507!3d-19.32659748694456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xb72c9762d8f7bf%3A0x545e6b542bc56e9e!2sResplendor+Center+Hotel!5e0!3m2!1spt-BR!2sbr!4v1489704108722",
      "width": "300",
      "height": "300",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('iframe', {
    staticClass: "right hide-on-small-only z-depth-4",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3764.98176657906!2d-41.25751408509507!3d-19.32659748694456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xb72c9762d8f7bf%3A0x545e6b542bc56e9e!2sResplendor+Center+Hotel!5e0!3m2!1spt-BR!2sbr!4v1489704108722",
      "width": "400",
      "height": "450",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brown-text col s12 m4 l4"
  }, [_c('h4', [_vm._v("LOCALIZAÇÃO")]), _vm._v(" "), _c('p', {}, [_vm._v("\n                    O Resplendor Center Hotel está localizado na Avenida Olegário Maciel, 364 B\n                    no Centro de Resplendor em Minas Gerais.\n                ")]), _vm._v(" "), _c('h5', [_vm._v("Como Chegar")]), _vm._v(" "), _c('p', [_vm._v("\n                    O Resplendor Center Hotel está aproximadamente 3,8 Km da ponte de Resplendor na BR259,\n                    e a 1 Km da Rodoviária.\n                ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-32b2364b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32b2364b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/hotel/localizacao.vue
// module id = 82
// module chunks = 0